module.exports = __webpack_public_path__ + "static/media/timetable_btn.c00a924e.svg";